const EVENT_TYPE_LABELS = {
  exhibition: { ru: 'Выставка', en: 'Exhibition' },
  expo: { ru: 'Экспо', en: 'Expo' },
  forum: { ru: 'Форум', en: 'Forum' },
  summit: { ru: 'Саммит', en: 'Summit' },
  conference: { ru: 'Конференция', en: 'Conference' },
  'business-tour': { ru: 'Бизнес-тур', en: 'Business Tour' },
};

const CASE_CATEGORY_LABELS = {
  manufacturing: { ru: 'Производство', en: 'Manufacturing' },
  logistics: { ru: 'Логистика', en: 'Logistics' },
  quality: { ru: 'Контроль качества', en: 'Quality Control' },
  trade: { ru: 'Торговля', en: 'Trade' },
  ecommerce: { ru: 'E-commerce', en: 'E-commerce' },
  investments: { ru: 'Инвестиции', en: 'Investments' },
};

const PROJECT_STAGE_LABELS = {
  seed: { ru: 'Seed', en: 'Seed' },
  'series-a': { ru: 'Series A', en: 'Series A' },
  growth: { ru: 'Рост', en: 'Growth' },
};

const PROJECT_INDUSTRY_LABELS = {
  logistics: { ru: 'Логистика', en: 'Logistics' },
  energy: { ru: 'Энергетика', en: 'Energy' },
  manufacturing: { ru: 'Производство', en: 'Manufacturing' },
  technology: { ru: 'Технологии', en: 'Technology' },
  electronics: { ru: 'Электроника', en: 'Electronics' },
};

const PROJECT_STATUS_LABELS = {
  active: { ru: 'Активный', en: 'Active' },
  pipeline: { ru: 'В работе', en: 'In Pipeline' },
  closed: { ru: 'Закрыт', en: 'Closed' },
};

const ARTICLE_CATEGORY_LABELS = {
  trade: { ru: 'Торговля', en: 'Trade' },
  logistics: { ru: 'Логистика', en: 'Logistics' },
  ecommerce: { ru: 'E-commerce', en: 'E-commerce' },
  quality: { ru: 'Контроль качества', en: 'Quality Control' },
  sustainability: { ru: 'Устойчивое развитие', en: 'Sustainability' },
  manufacturing: { ru: 'Производство', en: 'Manufacturing' },
  investments: { ru: 'Инвестиции', en: 'Investments' },
};

const PARTNER_CATEGORY_LABELS = {
  investments: { ru: 'Инвестиции', en: 'Investments' },
  logistics: { ru: 'Логистика', en: 'Logistics' },
  fulfillment: { ru: 'Фулфилмент', en: 'Fulfillment' },
  electronics: { ru: 'Электроника', en: 'Electronics' },
  manufacturing: { ru: 'Производство', en: 'Manufacturing' },
  quality: { ru: 'Контроль качества', en: 'Quality Control' },
  trade: { ru: 'Торговля', en: 'Trade' },
  shipping: { ru: 'Доставка', en: 'Shipping' },
};

function humanizeValue(value) {
  return String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getMappedLabel(map, value, lang) {
  if (!value) return '';
  const normalized = String(value).toLowerCase();
  return map[normalized]?.[lang] || humanizeValue(value);
}

export function getEventTypeLabel(value, lang) {
  return getMappedLabel(EVENT_TYPE_LABELS, value, lang);
}

export function getCaseCategoryLabel(value, lang) {
  return getMappedLabel(CASE_CATEGORY_LABELS, value, lang);
}

export function getProjectStageLabel(value, lang) {
  return getMappedLabel(PROJECT_STAGE_LABELS, value, lang);
}

export function getProjectIndustryLabel(value, lang) {
  return getMappedLabel(PROJECT_INDUSTRY_LABELS, value, lang);
}

export function getProjectStatusLabel(value, lang) {
  return getMappedLabel(PROJECT_STATUS_LABELS, value, lang);
}

export function getArticleCategoryLabel(value, lang) {
  return getMappedLabel(ARTICLE_CATEGORY_LABELS, value, lang);
}

export function getPartnerCategoryLabel(value, lang) {
  return getMappedLabel(PARTNER_CATEGORY_LABELS, value, lang);
}
